import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../api/hooks/useColors";
import SvgToIcon from "../../../icons/SvgToIcon";
import { ReactComponent as ChevronDownIcon } from "../../stack/environment/icons/chevron-down.svg";
import { ReactComponent as ChevronRightIcon } from "../../stack/environment/icons/chevron-right.svg";

export default function OnPremCollapseSection({
  title,
  children,
  defaultCollapsed = true,
  borderBottom = true,
}) {
  const colors = useColors();
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        paddingRight: 2,
        paddingTop: 2,
        paddingBottom: 3,
        borderBottom: borderBottom ? `1px solid ${colors.divider}` : "none",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        onClick={() => setCollapsed((prev) => !prev)}
        sx={{ cursor: "pointer" }}
        width="100%"
        gap={1}
      >
        <SvgToIcon
          IconLogo={collapsed ? ChevronRightIcon : ChevronDownIcon}
          width="20px"
          style={{ color: colors.active }}
        />
        <Typography variant="subtitle1">{title}</Typography>
      </Box>

      <Collapse in={!collapsed}>{children}</Collapse>
    </Box>
  );
}
